<div class="test-summary-header Flexbox Flexbox__just-space-around">
  <div class="header-text">Test Summary</div>
  <div>
    <input
      *ngIf="!isQcTest() && canShowSummaryInput() && !(enableAddendumInput$ | async)"
      class="btn btn-primary" type="button" value="Create addendum report"/>
  </div>
</div>

<section class="summary" id="content-div">

  <!-- "final review" or 'interpretation results'-->
  <div *ngIf="enableFor('interpretation')"
       class="Flexbox Flexbox__box-direction-column Marginbox__t-small Flexbox__box-align-start">
    <div *ngIf="!isQcTest()">
      <label>Add interpretation summary</label>
      <!-- TODO: Use angular forms, debounce from there-->
      <textarea [formControl]="interpretationTextControl"
                (change)="updateReview(interpretationText,'finalReview')"
                placeholder="Type interpretation summary here" rows="7"
                class="interpretation-summary-text" [maxLength]="maxInterpetationTextLength"></textarea>
      <span *ngIf="(interpretationTextControl.valueChanges | async)?.length === maxInterpetationTextLength"
            class="summary-error-message">The maximum allowed characters for interpretation summary is {{maxInterpetationTextLength}}</span>
      <input class="btn btn-primary Marginbox__t-small" type="button" value="Release final report"
             (click)="showWarningAndReleaseFinalReport()">
    </div>
    <div *ngIf="isQcTest()" class="qc-assign-state">
      <!-- Add QC assignment result -->
      <div class="state-selector">
        <gen-dropdown-with-title
          [config]="qcConfig"
          (selectedOption)="onQcOptionSelected($event)">
        </gen-dropdown-with-title>
      </div>
      <div class="Marginbox__t-small">
        <label>Notes</label>
        <!--TODO: use forms here -->
        <textarea [formControl]="interpretationTextControl"
                  id="addendum-input"
                  (change)="updateReview(interpretationText,'finalReview')"
                  rows="7" placeholder="Type notes here"
                  class="interpretation-summary-text" [maxLength]="maxInterpetationTextLength">
       </textarea>
        <input id="submitTest" class="btn btn-primary" type="button" value="Submit & Complete test"
               (click)="submitQcTest()">
      </div>
    </div>
  </div>

  <!-- "final review" or 'test completed'-->
  <div *ngIf="enableFor('completed')" class="Marginbox__t-small Marginbox__b-regular flexbox">
    <div *ngIf="isQcTest() && enableFor('test_completed')" class="qc-test-state">
      <div class="state-result">
        <label class="qc-state-title">QC state: </label>
        <label class="control_test_tag" [ngClass]="prepareClassName()" id="qcResultStatus">{{getResultStatus()}}</label>
      </div>
      <div class="Marginbox__t-small Flexbox item conclusion">
        <div class="left-content">
          <div class="field-title">{{getTranslationKey('notes') | translate}}</div>
          <div class="content break-line">{{currentTest.interpretationText}}</div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!isQcTest()">
      <div *ngFor="let conclusion of conclusions"
           class="Marginbox__t-small Flexbox item">
        <div class="left-content">
          <div class="field-title">{{getTranslationKey('text') | translate}}</div>
          <div class="content break-line">{{conclusion.text}}</div>
        </div>
        <div class="content-delimiter"></div>
        <div class="right-content">
          <div>
            <div class="field-title">
              <span class="icon__edit Spacebox__r-tiny"></span>
              <span>{{getTranslationKey('actorName') | translate}}</span>
            </div>
            <div class="content">{{conclusion.actorName}}</div>
          </div>
          <div class="Spacebox__t-medium">
            <div class="field-title">
              <span class="icon__clock Spacebox__r-tiny"></span>
              <span>{{getTranslationKey('date') | translate}}</span>
            </div>
            <div class="content">{{conclusion.date | date}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- show addendum report -->
    <div *ngIf="!isQcTest() && enableFor('allowed') && (enableAddendumInput$ | async)" class="Marginbox__t-medium">
       <textarea id="addendum-input"
                 [formControl]="addendumTextControl"
                 (change)="updateReview(addendumText,'addendumReview')"
                 rows="7" placeholder="Type interpretation summary here"
                 class="interpretation-summary-text" [maxLength]="maxInterpetationTextLength">
       </textarea>
      <span *ngIf="(addendumTextControl.valueChanges | async)?.length === maxInterpetationTextLength"
            class="summary-error-message">The maximum allowed characters for interpretation summary is {{maxInterpetationTextLength}}</span>
      <div class="Marginbox__t-small">
        <input class="btn btn-primary" type="button" value="Release" (click)="releaseAddendumReport()"
               [disabled]="!(addendumTextControl.valueChanges | async)">
        <input class="btn btn-default" type="button" value="Cancel" (click)="close()">
      </div>
    </div>
  </div>
</section>

